import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useThemeStore } from '../../stores/theme/useThemeStore.js';
import { AuthMainStepContent } from './AuthMainStepContent.js';
import { CenteredText } from '../common.js';
export const AuthMainStep = ({ oAuthMethods, disableEmailLogin, disablePhoneLogin }) => {
    const logo = useThemeStore(state => state.getLogo());
    const appName = useThemeStore(state => state.appName);
    const authLayout = useThemeStore(state => state.authLayout);
    const embeddedModal = useThemeStore(state => state.embeddedModal);
    const firstLayoutType = authLayout[0].split(':')[0];
    const heading = firstLayoutType === 'AUTH' ? 'Sign Up or Login' : 'Connect Wallet';
    return (_jsxs(_Fragment, { children: [logo && _jsx(Logo, { src: logo, alt: `${appName ? `${appName} -` : ''}logo` }), !embeddedModal && (_jsx(CenteredText, { variant: logo ? 'bodyM' : 'headingS', weight: "semiBold", children: heading })), _jsx(AuthMainStepContent, { disableEmailLogin: disableEmailLogin, disablePhoneLogin: disablePhoneLogin, oAuthMethods: oAuthMethods })] }));
};
const Logo = styled.img `
  height: 100px;
  max-width: 260px;
  object-fit: contain;
  padding: 16px 0px;
  margin: 16px 0px;
  box-sizing: content-box;
  align-self: center;
`;
